module.exports = __webpack_public_path__ + "img/Report-Misi-WorkValue20.a4f31eb0.png";